// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__21gs3","emails":"CreateEditClinics_emails__1kIw9","emailTagLabel":"CreateEditClinics_emailTagLabel__1w-Lf"};